import { CSSObject } from '@chakra-ui/react';
import { IS_MOBILE_APP } from '../../../constants/isMobileApp';
import { AccountWrapperSchema } from './AccountWrapperTwo.styles';

export const accountWrapperStyles: AccountWrapperSchema = {
  boxWrapper: {
    pt: [IS_MOBILE_APP ? '2' : '0', null, 'unset'],
    mx: 'unset',
    mb: 4,
    borderRadius: 'md',
    bgGradient: [
      'transparent',
      null,
      null,
      'linear(to-b, rgba(97, 116, 182, 0.7), rgba(68, 85, 144, 0.7))',
    ],
    boxShadow: [
      'unset',
      null,
      null,
      '0px 1px 5px 0px rgba(130, 151, 222, 1) inset,  0px 4px 8px 0px rgba(0, 0, 0, 0.45)',
    ],
  },
  boxHeading: {
    pt: '0',
    mb: 0,
    mx: ['-2.5', 0],
    ...(!IS_MOBILE_APP && {
      pb: '9',
    }),
    color: 'white',
  },
  textTitle: {
    mt: '0',
    color: 'white',
    fontSize: ['lg', 'xl'],
    fontWeight: 'normal',
    fontFamily: 'accent',
    textShadow: '0px 2px 4px rgba(0, 0, 0, 0.25)',
  },
  accountHeaderContainer: {
    sx: {
      '&&': {
        px: '0',
        borderTopRadius: 'md',
      },
    },
  },
  accountInfoContainer: {
    sx: {
      '&&': {
        borderBottomRadius: 'md',
        pb: '2.5',
        display: 'flex',
        gap: '4',
      },
    },
  },
  titleContainer: {
    pr: ['2', '4'],
    pb: '2',
    ...(IS_MOBILE_APP && {
      p: '2',
      pb: '0',
      h: 'unset',
    }),
  },
  flexVerticalWrapper: {
    flexDir: 'column',
    w: '100%',
    borderRadius: 'md',
    px: '3',
    py: '3',
    bgGradient: 'linear(to-b, beta.300, beta.400)',
    shadow:
      '0px 4px 4px 0px rgba(0, 0, 0, 0.25), 0px 0px 0px 1px rgba(255, 255, 255, 0.15) inset',
  },
};
export const BoxHeading: CSSObject = {
  pt: '0',
  mb: 0,
  ...(!IS_MOBILE_APP && {
    pb: '9',
  }),
  color: 'white',
};
